import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import { useSelector,useDispatch } from 'react-redux';
import {getFakturaIntervallbyAfid} from 'actions'
import IntlMessages from 'util/IntlMessages';

function Fakturaintervall(props) {
    const dispatch = useDispatch()
    const [ArendeStatus,setArendeStatus] = React.useState(0)
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const FakturaIntervall = useSelector(state => state.accountsData.FakturaIntervall)
    const getAvtalType=(e)=>{
        let Meta = "Fakturaintervall"
        props.onChangeHandle(Meta,e.target.value)        
    }
    React.useEffect(()=>{
        dispatch(getFakturaIntervallbyAfid(Afid))
    },[])
    return (
        <div style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
            select
            label={<IntlMessages id="input.invoice.Options" />}
            variant="outlined"
            size="small"
            value={ArendeStatus}
            fullWidth
            onChange={getAvtalType}
            SelectProps={{
                native: true,
            }}
        >
            <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
            {
          !isEmpty(FakturaIntervall)?
          FakturaIntervall.map(option =>(
          <option value={option.BillingIntervall}>
          {option.BillingIntervall} <IntlMessages id="month.lowerCase" />
          </option>
          ))          
          :""}
        </TextField>
    </div>
    );
}

export default Fakturaintervall;